import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-unavailable.dialog',
  standalone: false,
  templateUrl: './unavailable.dialog.component.html',
  styleUrl: './unavailable.dialog.component.scss'
})
export class UnavailableDialogComponent {
  attribute = inject<string>(MAT_DIALOG_DATA);
}
